module.exports = __webpack_public_path__ + "img/23FB.c1a432e8.svg";